import React from "react";

const HowToPlay = () => {
  return (
    <div className="Associate__container">
      <div className="box">
        
      <h1>How to play</h1>
      <h2>
      Here’s what you need to know to join our contests:</h2>
          <ul>
            <li>
              <b>Total winnings</b>
              Total winnings for a particular contest is distributed among the
              winners who are finalised on the basis of their rankings.
            </li>
            <li>
              <b>Winners</b>
              This is the total number of proposed winners in a contest. The
              number of winners is directly proportional to the number of teams
              joining the contest.
            </li>
            <li>
              <b>Entry fee</b>
              This is the entry fee which needs to be paid to join a contest.
              The entry fee can be cash, ticket, or free.
            </li>
            <li>
              <b>Prize breakup</b>
              This is the prize that is distributed depending on the ranks
              achieved by the participants. Once a match goes live, the prize
              breakup is updated based on the number of participants that have
              joined the contest.
            </li>
            <li>
              <b>Participants joined/Contest Size</b>
              This indicates the number of participants that have joined the
              contest on a real time basis, also displaying the maximum number
              of participants allowed to join the contest.
            </li>
            <li>
              <b>Flexible and Non-Flexible</b>
              This symbol indicates whether a contest is flexible or not. If a
              contest is non-flexible, it means that the prize for a particular
              rank is guaranteed, although the number of prizes vary as and when
              more participants join the contest.
            </li>
          </ul>
      
        <h2>1. How to play the coinstorey game?</h2>
        <ul>
          <li>Go to ‘contests’ &gt; ‘public’.</li>
          <li>
            Pick a contest and create your fantasy portfolio using the 100000
            virtual money in your kit.
          </li>
          <li>
            If you are new to the world of fantasy crypto games and want to
            explore it, join our ‘Practice’ contests. Here, you do not have to
            pay an entry fee. Play for free and challenge other contestants.
          </li>
          <li>
            If you want to win prize money, discover various contests such as
            Mega, Beat the Expert, Beat the Score, Head to head etc.
          </li>
          <li>
            You can also create your own Private contest and invite your friends
            and family to test their skills.
          </li>
          <li>
            Your fantasy portfolio will start earning points once the contest
            goes live. Check progress in the ‘Live’ tab.
          </li>
          <li>
            Your final profit will be updated once the contest is over. Go to
            ‘contest’ &gt; ‘Completed’ to check others' portfolios and rankings.
          </li>
          <li>
            The amount you win depends on the performance of your portfolio
            chosen by you, and it will reflect in your coinstorey wallet after 4
            hours of the match being in completed state.
          </li>
          <li>
            To withdraw any cash from your account, go to: coinstorey wallet
            Withdraw Cash
          </li>
          
        </ul>
        <h2>2. How to join a contest?</h2>
      <ul>
        <li>
          Go to ‘Public Contest’ and select a contest you’d like to play for.
        </li>
        Scan through various contests, such as:
        <li>
          <b>Cash contests</b>
          There are various types of contests that help you win cash prizes:
          Mega, Beat the Expert, Beat the Score, Head to head etc. These
          contests have a fixed entry fee designed by our management team.
          Although you can create a portfolio for free, you’ll have to pay an
          entry fee when you join a contest. You can also create cash private
          contests (under ‘Private Contests’) and compete amongst your friends.
          It is you who decides the entry fees and cash prizes for the Private
          contests.
        </li>
        <li>
          <b>Practice contests</b>
          If you are new to the world of fantasy games and want to explore it,
          you may play the Practice contests. Here, you do not have to pay an
          entry fee. Play for free and see your ranking amongst the best of the
          fantasy players.
        </li>
        </ul>
        <h2>3. How can I host a Private contest?</h2>
        <ul>
          <li>Go to ‘contest’ &gt; ‘private’ &gt; ‘create’</li>
          <li>
            Now click on ‘Private contest’ button to reach the private contest
            creation page
          </li>
          <li>
            By default, values for setting the private contest is already
            provided, you may modify them based on your requirement
          </li>
          <li>
            Click on the “create” button and your private contest is ready
          </li>
          <li>
            Share the unique link with your friends to invite them on your
            private contest
          </li>
          <li>
            You can also join the private contest hosted by yourself by clicking
            on ‘Join Contest’ button
          </li>
          </ul>
          <h2>4. How can I join a private contest?</h2>
          <ul>
            <li>
              If you have received an invite for a private contest, you can
              simply join it by clicking on the unique link in the invite
              message
            </li>
            <li>
              If you have received an invite code, you can copy it and paste in
              the ‘Join Private Contest’
            </li>
            <li>
              You will see the details of the contest and the private contest
              that you have been invite for, you can join by clicking on the
              ‘Join’ button
            </li>
            <li>
              After joining, you can share the invite link with more of your
              friends
            </li>
            <li>
              I am getting an error when I am trying to join a private contest
              through the invite code or invite link You can join a private
              contest only before the start of the contest
            </li>
            <li>
              So the contest for which you are entering the invite code may
              already have been started
            </li>
          </ul>
        
      
        <h2>4. How is the winner decided?</h2>
        <ul>
          <li>
            {" "}
            Winning positions are decided on the basis of ranks achieved by
            various participants. The ranks are finalised on the basis of total
            profit accumulated by participants.
          </li>
          <li>
            For example, consider the following contest details:
            <pre>
              Total winnings - ₹3,00,000 Contest Size - ₹200 Winners - ₹100
              Entry Fee - ₹2000
            </pre>
            Prize breakup:
            <pre>
              Rank 1: ₹1,00,000 Rank 2: ₹60,000 Rank 3: ₹20,000 Rank 4-10:
              ₹5,000 Rank 11-100: ₹1,000
            </pre>
          </li>
          <li>
            Once a contest is closed, the prize breakup is recalculated on the
            basis of the number of participants that have joined the contest.
            For this example, let’s consider the maximum participants allowed to
            join the contest.
          </li>
          <li>
            Once the match finishes, all the participants that have joined will
            have a fixed rank on the basis of the profit they have accumulated.
          </li>
          <li>
            So, if you had joined this contest and you achieved a rank between 1
            and 100, you are a winner and the amount committed in the prize
            breakup corresponding to your rank is your winning amount.
          </li>
          <li>
            Please note that cash prizes and rankings are different for
            different contests.
          </li>
        </ul>
        {/* <h3>
          Contact us Still have any query? Mail us on :- team@coinstorey.com
        </h3>
          <h3>
            How can I share the private contest I created with my friends?
          </h3>
          <ul>
            <li>
              Once the private contest is created successfully, you will be
              redirected to the invite page
            </li>
            <li>
              On this page, you can see the option to share the invite code
              through different mediums such as Whatsapp, SMS or any other
              sharable medium (using ‘more’ option)
            </li>
            <li>
              You can share the unique link for your private contest on any of
              the mediums
            </li>
            <li>
              You friends can click the shared link and join your private
              contest anytime before the start of the contest
            </li>
          </ul>
          <h3>What are the rules of Private contest?</h3>
          <ul>
            <li>
              All the game rules for the private contest are the same as that of
              the regular contest
            </li>
          </ul>
          <h3>How do I withdraw cash?</h3>
          <ul>
            <li>
              You can Withdraw Cash at any time by going to My wallet page and
              clicking on Withdraw Cash.
            </li>
            <li>
              You are then asked to enter an amount you would like to withdraw.
            </li>
            <li>
              You can only withdraw an amount less than or equal to your
              Withdrawable Balance. This will be shown to you on the Withdraw
              Cash page.
            </li>
            <li>
              For making a withdrawal, you need to be ID verified. If you are
              not ID verified, then on placing a withdrawal request you shall be
              prompted to upload the latest copy of ID proof. Our customer
              service team will review and verify your uploaded document. You
              can also get yourself ID verified by uploading an ID proof
              document from the Profile section under My accounts.
            </li>
            <li>
              A TDS certificate will be provided to you 3 months from the
              winning date, on your registered email address.
            </li>
          </ul>
         
          You can withdraw upto 75000 in 3 trench per day.
          <h2>Login & Registration</h2>
          <h3>How do I register?</h3>
          <ul>
            <li>Enter your mobile number.</li>
            <li>You will receive an OTP, please input that to move forward.</li>
            <li>Enter your name</li>
            <li>Enter your 4-digit PIN to set up your account</li>
          </ul>
          <h3>How do I reset my PIN?</h3>
          <ul>
            <li>Click on forgot PIN</li>
            <li>
              You will receive OTP on your registered mobile number, please
              input that to move forward Reset your PIN
            </li>
          </ul>
    
        <h2>Hacking awareness</h2>
        <h3>What to Do Before You’re Hacked</h3>
        <ul>
          <li>
            Use unique passwords for important sites, like your bank and email
            That way, someone who knows one of your passwords won’t suddenly
            have access to all your important accounts.
          </li>
          <li>
            Choose strong passwords that are harder to crack. Some people find
            password managers — software that stores and remembers your
            passwords for you — a helpful way to keep things straight. If you
            use a password manager, make sure to select a unique, strong
            password for it, too. Many password managers will let you know
            whether the master password you’ve created is strong enough.
          </li>
          <li>
            Safeguard your usernames and secret passwords Think twice when
            you’re asked to enter credentials like usernames and secret
            passwords. Never provide them in response to an email. If the email
            or text seems to be from your bank, for example, visit the bank
            website directly rather than clicking on any links or calling any
            numbers in the message. Scammers impersonate well-known businesses
            to trick people into giving out personal information. ECSU will
            never, never ask for your secret password.
          </li>
          <li>
            Turn on two-factor authentication if your service provider offers it
            A number of online services offer “two-factor authentication,” where
            getting into your account requires a password plus something else —
            say, a code sent to your smartphone — to prove it’s really you.
          </li>
          <li>
            Don’t click on links or open attachments in emails unless you know
            who sent them and what they are That link or attachment could
            install malware on your computer. Also do your part: don’t forward
            random links.
          </li>
          <li>
            Download free software only from sites you know and trust If you’re
            not sure who to trust, do some research before you download any
            software. Free games, file-sharing programs, and customized toolbars
            also could contain malware.
          </li>
          <li>
            Don’t treat public computers like your personal computer If it’s not
            your computer, don’t let a web browser remember your passwords, and
            make sure to log out of any accounts when you’re done. In fact, if
            you can help it, don’t access personal accounts — like email, or
            especially bank accounts — on public computers at all. (Also be
            careful any time you use public Wi-Fi.)
          </li>
          <li>
            Learn more at the Federal Trade Commission website
            https://www.consumer.ftc.gov/topics/privacy-identity-online-security
          </li>
        </ul>
        <h4>
          How to Keep Your Personal Information Secure Protecting your personal
          information can help reduce your risk of identity theft. There are
          four main ways to do it: know who you share information with; store
          and dispose of your personal information securely, especially your
          Social Security number; ask questions before deciding to share your
          personal information; and maintain appropriate security on your
          computers and other electronic devices.
        </h4> */}
      </div>
    </div>
  );
};

export default HowToPlay;
